export const ucFirst = (str: any) => {
  if (!str) return str;

  return str[0].toUpperCase() + str.slice(1);
};
